module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/favicon-16x1648c76d7d92c5d33fd884e585318990f2.png";